import React from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './NotificationList.module.scss';
import { AppState } from '../../../../reducers/root.reducer';
import Notification from '../Notification/Notification';
import { INotification } from '../../../../types/common/INotification';

const ANIM_TIMEOUT = 400;

export default function NotificationList() {
    const notifications: INotification[] = useSelector(
        (state: AppState) => state.common.notifications,
    );

    return (
        <TransitionGroup
            className={styles.list}
            style={{ '--timeout': `${ANIM_TIMEOUT}ms` }}
        >
            {notifications.map((notification: INotification) => (
                <CSSTransition
                    key={notification.timestamp}
                    classNames={{
                        enter: styles.enter,
                        enterActive: styles['enter-active'],
                        exit: styles.exit,
                        exitActive: styles['exit-active'],
                    }}
                    timeout={ANIM_TIMEOUT}
                >
                    <Notification notification={notification} />
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
}
